export default __webpack_public_path__ + "static/media/8B.30db8e3e.png";